module.exports = __webpack_public_path__ + "img/web8.55ac5900.png";